import I18n from "i18n-js";
import React from "react";

class UploadGroupBuilder extends React.Component {

  constructor(props) {
    super(props);
    this.renderAddButton = this.renderAddButton.bind(this)
    this.renderUploads = this.renderUploads.bind(this)
    this.renderUpload = this.renderUpload.bind(this)
    this.removeUpload = this.removeUpload.bind(this)
    this.uploads = React.createRef();
  };

  componentDidMount() {
    var self = this
    
    window.insertUploads = function(uploads) {
      var uploadGroup

      if (self.props.upload_groups) {
        uploadGroup = self.props.upload_groups[0];
      } else {
        uploadGroup = {[self.props.upload_type_plural]: []};
      }

      if (!uploadGroup[self.props.upload_type_plural] || !uploadGroup[self.props.upload_type_plural].length) {
        uploadGroup[self.props.upload_type_plural] = [];
      }

      uploadGroup[self.props.upload_type_plural] = uploadGroup[self.props.upload_type_plural].concat(uploads)

      self.props.onChange(uploadGroup)
    };
  };

  render() {
    var self = this
    var uploadGroup = this.props.upload_groups ? this.props.upload_groups[0] : {images: []};
    $( function() {
      $( "#sortable").sortable({
        handle: ".handle",
        stop: function(event,ui) {
          var idsInOrder = $( "#sortable" ).sortable( "toArray" )
          self.props.onChangeOrder(idsInOrder) 
        }
      });
    });

    return (
      <div id="uploads">
        <div className="row">
          <div className="col-md-12">
          <div className="panel panel-default" style={{marginBottom: 0}}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6">
                  <h3 className="panel-title">
                    {this.props.dropzone_title ? I18n.t(this.props.dropzone_title) : I18n.t(this.props.upload_type_plural)} <span className="ss-help help" title={I18n.t(this.props.helperText)}></span>
                  </h3>
                </div>
                {this.renderAddButton(uploadGroup)}
              </div>
              <div className="panel-body">
                {this.renderUploads(uploadGroup)}
              </div>
            </div>
          </div>
        </div>
      </div>  
    );
  };

  renderAddButton(uploadGroup) {
    if (this.props.read_only !== true) {
      if (!this.props.multiple && uploadGroup[this.props.upload_type_plural].length) {
        return null
      };

      return (
        <div className="col-md-6 content-right flexed">
          <div className="add-button">
            <a className="modal-iframe btn btn-secondary" data-fullscreen="true" href={this.props.data_table_path + '?insert=true&multiple=' + (this.props.multiple ? 'true' : 'false') + '&filter_size=' + (this.props.filterSize ? 'true' : 'false') + '&origin=' + (this.props.origin ? this.props.origin : '')}>{I18n.t('add')}</a>
          </div>
        </div>
      );
    };
  };

  renderUploads(uploadGroup) {
    var self = this;
    var idx = -1;
    var uploads = uploadGroup[this.props.upload_type_plural] && uploadGroup[this.props.upload_type_plural].length ? uploadGroup[this.props.upload_type_plural].sort(function (a, b) {
      if (a.position < b.position) return -1;
      if (a.position > b.position) return 1;
      return 0;
    }).map(function (upload) {
      idx = idx + 1;
      return self.renderUpload(upload, idx);
    }) : null;

    if (uploads == null || uploads.length == 0) {
      return (
        <div className="no-records"><span className="none">{I18n.t('none')}</span></div>
      );
    } else {
      return (
        <div id="sortable" className="sortable-images" style={{ display: 'block', padding: '1rem' }}>{uploads}</div>
      );
    };
  };

  renderUpload(upload, idx) {
    return (
      <div id={upload.id} className="sortable-upload" data-id={upload.id} key={upload.id + idx}>
        <div className="image-row">
          {this.props.read_only || this.props.multiple == false ? null : <span className="handle">&#9776;</span>}
          <div className="col-sm-2">
            <a href={upload.original_url} className="open-new-window" target="_blank"><span className="ss-scaleup"></span> <img src={upload.thumb_medium_url} /></a>
          </div>
          <div className="col-sm-2 file_name">{upload.upload_file_name}</div>
          <div className="col-sm-2">{upload.upload_content_type}</div>
          {this.props.displayImageTypes ? <div className="col-sm-2">{this.renderImageTypeSelect(upload)}</div> : null}
          <div className="col-sm-2 remove-image-button">
            <input type="hidden" name={'upload_group' + this.props.upload_type_plural + this.props.upload_type + '_id[]'} value={upload.id} />
            <input type="hidden" name={'upload_group' + this.props.upload_type_plural + upload.id + '_position'} className="position" value={idx} />
            {this.props.read_only ? null : <button type="button" className="pull-right btn btn-secondary btn-sm remove-btn" onClick={this.removeUpload.bind(null, upload.id)}>{I18n.t('remove')}</button>}
          </div>
        </div>
      </div>
    );
  };

  removeUpload(id) {
    if (this.props.upload_groups && this.props.upload_groups.length) {
      var uploadGroup = this.props.upload_groups[0];
      for (var i = 0, ilen = uploadGroup[this.props.upload_type_plural].length; i < ilen; i++) {
        if (uploadGroup[this.props.upload_type_plural][i].id == id) {
          uploadGroup[this.props.upload_type_plural].splice(i, 1);
          break;
        };
      };
      this.forceUpdate();
      if (typeof this.props.onChange == 'function') {
        this.props.onChange(uploadGroup);
      };
    };
  };

  renderImageTypeSelect = (upload) => {
    var activitiesOptions = this.props.image_types.filter(imageType => imageType.description.startsWith('Activities'))
      .map((activitiesImageType) => {
        return <option key={activitiesImageType.id} value={activitiesImageType.id}>{activitiesImageType.description.split(': ')[1]}</option>
      });

    var diningOptions = this.props.image_types.filter(imageType => imageType.description.startsWith('Dining'))
      .map((activitiesImageType) => {
        return <option key={activitiesImageType.id} value={activitiesImageType.id}>{activitiesImageType.description.split(': ')[1]}</option>
      });

    var exteriorOptions = this.props.image_types.filter(imageType => imageType.description.startsWith('Exterior'))
      .map((activitiesImageType) => {
        return <option key={activitiesImageType.id} value={activitiesImageType.id}>{activitiesImageType.description.split(': ').length > 1 ? activitiesImageType.description.split(': ')[1] : activitiesImageType.description}</option>
      });
      
    var interiorOptions = this.props.image_types.filter(imageType => imageType.description.startsWith('Interior'))
      .map((activitiesImageType) => {
        return <option key={activitiesImageType.id} value={activitiesImageType.id}>{activitiesImageType.description.split(': ').length > 1 ? activitiesImageType.description.split(': ')[1] : activitiesImageType.description}</option>
      });

    var roomsOptions = this.props.image_types.filter(imageType => imageType.description.startsWith('Rooms'))
      .map((activitiesImageType) => {
        return <option key={activitiesImageType.id} value={activitiesImageType.id}>{activitiesImageType.description.split(': ').length > 1 ? activitiesImageType.description.split(': ')[1] : activitiesImageType.description}</option>
      });

    var mainImage = this.props.image_types.filter(imageType => imageType.description.startsWith('Main Image'))
      .map((activitiesImageType) => {
        return <option key={activitiesImageType.id} value={activitiesImageType.id}>{activitiesImageType.description.split(': ').length > 1 ? activitiesImageType.description.split(': ')[1] : activitiesImageType.description}</option>
      });

    var otherOptions = this.props.image_types.filter(imageType => imageType.description.startsWith('Other'))
      .map((activitiesImageType) => {
        return <option key={activitiesImageType.id} value={activitiesImageType.id}>{activitiesImageType.description.split(': ').length > 1 ? activitiesImageType.description.split(': ')[1] : activitiesImageType.description}</option>
      });

    var poolOptions = this.props.image_types.filter(imageType => imageType.description.startsWith('Pool'))
      .map((activitiesImageType) => {
        return <option key={activitiesImageType.id} value={activitiesImageType.id}>{activitiesImageType.description.split(': ').length > 1 ? activitiesImageType.description.split(': ')[1] : activitiesImageType.description}</option>
      });

    return (
      <label className="form-group" style={{marginBottom:'0px'}}>
        {I18n.t('description')}: 
        <select id={upload.id} className="form-control" value={upload.image_type_id ? upload.image_type_id : ''} onChange={this.props.onChangeImageType} >
          <option value="" disabled>{I18n.t("select_ellipsis")}</option>
          {mainImage}

          <optgroup label={I18n.t('rooms')}>
            {roomsOptions}
          </optgroup>

          <optgroup label={I18n.t('interior')}>
            {interiorOptions}
          </optgroup>

          <optgroup label={I18n.t('exterior')}>
            {exteriorOptions}
          </optgroup>

          <optgroup label={I18n.t('activities')}>
            {activitiesOptions}
          </optgroup>

          <optgroup label={I18n.t('dining')}>
            {diningOptions}
          </optgroup>

          <optgroup label={I18n.t('other')}>
            {[...otherOptions, ...poolOptions]}
          </optgroup>

        </select>
      </label>
    )
  };
};

export default UploadGroupBuilder;
